import React, { Component, Fragment } from 'react';
import MyButton from '../../../utils/MyButton';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './CargarFirmaCliente.css';



import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FaPlusCircle, FaArrowLeft, FaPlus, FaSignature, FaCloudUploadAlt, FaFileSignature } from "react-icons/fa";
import { subirFirmaCliente } from '../../../redux/actions/dataactions';
import Dropzone from 'react-dropzone';


export class CargarFirmaCliente extends Component {
    state = {
        // Initially, no file is selected 
        selectedFile: null,
        open: false
    };
    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    onFileChange = (acceptedFiles) => {
        // Update the state with the first file dropped
        if (acceptedFiles && acceptedFiles.length > 0) {
            this.setState({ selectedFile: acceptedFiles[0] });
        }
    };

    onFileUpload = () => {

        // Create an object of formData 
        const formData = new FormData();

        // Update the formData object 
        formData.append(
            "myFile",
            this.state.selectedFile,
            this.state.selectedFile.name
        );
        console.log(formData);
        console.log(this.props.clienteId);
        this.props.subirFirmaCliente(formData, this.props.clienteId);
        //Imagen subida

        //
        this.setState({ open: false });

    };


    render() {
        return (
            <div>
                <Fragment>
                    <div className="div-botoneliminarcliente">
                        <MyButton tip="Subir Firma Cliente" onClick={this.handleOpen}>
                            <FaSignature color="#03178C" className="icon-eliminarcliente" />
                        </MyButton>
                    </div>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>Subir Firma del Cliente</DialogTitle>

                        <DialogContent>
                            <Dropzone
                                onDrop={this.onFileChange}
                                accept={{ 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] }}
                                multiple={false}
                            >
                                {({ getRootProps, getInputProps, isDragActive }) => (
                                    <Box
                                        {...getRootProps()}
                                        sx={{
                                            border: '2px dashed #03178C',
                                            borderRadius: '8px',
                                            padding: '40px',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            backgroundColor: isDragActive ? '#e0e7ff' : '#f9f9f9',
                                            transition: 'background-color 0.3s ease',
                                            mt: 2,
                                            mb: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minHeight: '200px'
                                        }}
                                    >
                                        <input {...getInputProps()} />

                                        {this.state.selectedFile ? (
                                            <Fragment>
                                                <FaFileSignature size={50} color="#20B90C" style={{ marginBottom: '15px' }} />
                                                <Typography variant="h6" color="textSecondary">
                                                    Archivo seleccionado:
                                                </Typography>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#03178C' }}>
                                                    {this.state.selectedFile.name}
                                                </Typography>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <FaCloudUploadAlt size={60} color="#03178C" style={{ marginBottom: '15px' }} />
                                                <Typography variant="h6" color="textSecondary" sx={{ mb: 1 }}>
                                                    {isDragActive ? "Suelta la imagen aquí..." : "Arrastra y suelta la firma aquí"}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    o haz clic para seleccionar un archivo (.jpg, .png)
                                                </Typography>
                                            </Fragment>
                                        )}
                                    </Box>
                                )}
                            </Dropzone>
                        </DialogContent>

                        <DialogActions>
                            <MyButton tip="Cerrar" onClick={this.handleClose}>
                                <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                            </MyButton>
                            <MyButton
                                tip="Subir Imagen"
                                onClick={this.onFileUpload}
                                btnClassName={!this.state.selectedFile ? "disabled-btn" : ""}
                                disabled={!this.state.selectedFile}
                            >
                                <FaPlus color={this.state.selectedFile ? "#03178C" : "#A0A0A0"} className="icon-formulario" />
                            </MyButton>

                        </DialogActions>

                    </Dialog>




                </Fragment>

            </div>
        )
    }
}

//en propiedades recibe el cliente id 
CargarFirmaCliente.propTypes = {
    subirFirmaCliente: PropTypes.func.isRequired,
    handleuser: PropTypes.string.isRequired
};

const mapActionsToProps = { subirFirmaCliente };

const mapStateToProps = (state) => ({
    user: state.user
})



export default connect(mapStateToProps, mapActionsToProps)(CargarFirmaCliente);

